// Import images
import Vanilla from "./assets/images/Vanilla.png";
import DarkSugar from "./assets/images/BrownSugar.png";
import Caramel from "./assets/images/Caramel.png";
import Sugar from "./assets/images/Sugar.png";

const syrups = {
  "Vanilla Syrup": {
    image: Vanilla,
    ingredients: {
      "Water": { "Water": { amount: 250, unit: "ml" } },
      "Sugars": { "Sugar": { amount: 200, unit: "g" } },
      "Flavoring": { "Vanilla Extract": { amount: 2, unit: "tsp" } }
    },
    instructions: "Boil water and sugar until dissolved. Add vanilla extract and let cool."
  },
  "Dark Sugar Syrup": {
    image: DarkSugar,
    ingredients: {
      "Water": { "Water": { amount: 250, unit: "ml" } },
      "Sugars": { "Brown Sugar": { amount: 200, unit: "g" } }
    },
    instructions: "Simmer water and brown sugar until thickened. Let cool before use."
  },
  "SaltedCaramel": {
    image: Caramel,
    ingredients: {
      "Water": { "Water": { amount: 250, unit: "ml" } },
      "Sugars": { "Sugar": { amount: 200, unit: "g" } },
      "Flavoring": { "Vanilla Extract": { amount: 2, unit: "tsp" } }
    },
    instructions: "Boil water and sugar until dissolved. Add vanilla extract and let cool."
  },
  "Simple Syrup": {
    image: Sugar,
    ingredients: {
      "Water": { "Water": { amount: 250, unit: "ml" } },
      "Sugars": { "Brown Sugar": { amount: 200, unit: "g" } }
    },
    instructions: "Simmer water and brown sugar until thickened. Let cool before use."
  }
};

export default syrups;
